import { render } from "./CreateCountry.vue?vue&type=template&id=74f164d8"
import script from "./CreateCountry.vue?vue&type=script&lang=js"
export * from "./CreateCountry.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__